/*
 * File: ProcedureForm.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 05/03/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Controls the Procedures form in post charges
 */
import React from "react";
import Preferences from "services/preferences/Store";
import ProcedureFormTextFields from "./ProcedureFormTextFields";
import ProcedureFormDoubleButtons from "./ProcedureFormDoubleButtons";
import ProcedureFormEditButton from "./ProcedureFormEditButton";
import ProcedureFormSwitchList from "./ProcedureFormSwitchList";
import { Theme, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useStore } from "utils/useStore";
import { WithStyles } from "@material-ui/core";
import { Instance } from "mobx-state-tree";
import PostChargesModel from "../../store/PostChargesModel";
import ChargeModel from "../../store/ChargeModel";

// --------------------------------------------
const styles = (theme: Theme) => ({
  diagnosisLabel: {
    marginLeft: theme.spacing(2.5),
    marginTop: theme.spacing(4),
    fontWeight: 400,
    color: theme.palette.common.title
  }
});

interface Props extends WithStyles<typeof styles> {
  editing: unknown;
  formSubmitMethod: () => void;
  chargeModel: Instance<typeof ChargeModel>;
  postChargesModel: Instance<typeof PostChargesModel>;
  procedureAddAnotherCallBack: () => void;
}

const ProcedureForm = ({
  editing,
  formSubmitMethod,
  chargeModel,
  postChargesModel,
  classes,
  procedureAddAnotherCallBack
}: Props) => {
  const preferencesStore = useStore(Preferences);

  const onSubmit = () => {
    formSubmitMethod();
  };
  const onAddAother = () => {
    postChargesModel.addCharge(chargeModel);
    procedureAddAnotherCallBack();
  };
  return (
    <React.Fragment>
      <ProcedureFormTextFields
        chargeModel={chargeModel}
        allowModifiers={preferencesStore.get("allowModifiers")}
        allowToothAndSurface={preferencesStore.get("allowToothSurface")}
      />
      <Typography className={classes.diagnosisLabel} variant="h5">
        Diagnosis
      </Typography>
      <ProcedureFormSwitchList chargeModel={chargeModel} />
      {editing && <ProcedureFormEditButton onSaveClick={onSubmit} />}
      {!editing && (
        <ProcedureFormDoubleButtons
          onReviewClick={onSubmit}
          onAddAnotherClick={onAddAother}
        />
      )}
    </React.Fragment>
  );
};

export default withStyles(styles)(ProcedureForm);
